import { render, staticRenderFns } from "./TransactionContentHead.vue?vue&type=template&id=48d270c2&"
import script from "./TransactionContentHead.vue?vue&type=script&lang=js&"
export * from "./TransactionContentHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports